import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  makeStyles,
} from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { translator } from "../../utils/Translator";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 12,
    boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
  },
  cardContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    position: "relative",
    "&:last-child": {
      paddingBottom: theme.spacing(2),
    },
  },
  actionButton: {
    border: "1px solid orange",
    marginLeft: theme.spacing(1),
    "& svg": {
      color: "orange",
    },
  },
}));

const DiscountList = ({ discounts, onEdit, onDelete }) => {
  const classes = useStyles();
  const { translate } = useSelector(({ i18n }) => i18n);

  // ถ้าไม่มีส่วนลด ให้ return null (ไม่แสดงอะไร)
  if (!discounts || discounts.length === 0) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      {discounts.map((item, index) => (
        <Card key={item.id || index} className={classes.card} variant="outlined" style={{ border: "1px solid #e0e0e0" }}>
          <CardContent className={classes.cardContent}>
            {/* ฝั่งข้อความ */}
            <Box flex={1}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold", marginBottom: 4 }}>
                {index + 1}. {item.discountName || `${translator(translate.ISA_DiscountItemStep, "ส่วนลดรายการ ขั้นที่")} ${index + 1}`}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {translator(translate.ISA_DiscountType, "ประเภทส่วนลด")} : {item.discountType === "P" ? translator(translate.ISA_Master_Percentage, "เปอร์เซ็น") : item.discountType === "A" ? translator(translate.ISA_Expense_Amount, "จำนวนเงิน") : translator(translate.ISA_Qty, "จำนวน")} &nbsp;|&nbsp; 
                {translator(translate.ISA_DiscountAmount, "จำนวนส่วนลด")} : {item.discountAmount}{item.discountType === "P" ? "%" : ""}
              </Typography>
            </Box>

            {/* ปุ่ม action */}
            <Box display="flex" alignItems="center" style={{ position: "relative", zIndex: 10 }}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  console.log("Edit discount clicked:", item);
                  if (onEdit) {
                    onEdit(item);
                  } else {
                    console.warn("onEdit is not defined");
                  }
                }}
                style={{ 
                  border: "1px solid #ff6f00", 
                  padding: 4,
                  cursor: "pointer",
                  pointerEvents: "auto"
                }}
              >
                <Edit fontSize="small" style={{ color: "#ff6f00" }} />
              </IconButton>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  console.log("Delete discount clicked:", item.id);
                  if (onDelete) {
                    onDelete(item.id);
                  } else {
                    console.warn("onDelete is not defined");
                  }
                }}
                style={{ 
                  border: "1px solid #ff6f00", 
                  padding: 4, 
                  marginLeft: 8,
                  cursor: "pointer",
                  pointerEvents: "auto"
                }}
              >
                <Delete fontSize="small" style={{ color: "#ff6f00" }} />
              </IconButton>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default DiscountList;